import React from 'react';
import { useNode } from '@craftjs/core';
import { TextField, FormControl, FormLabel, Divider as MuiDivider } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  divider: {
    margin: theme.spacing(2, 0),
    cursor: 'pointer',
    '&:hover': {
      backgroundColor: '#2196f3',
    },
  },
  settings: {
    padding: theme.spacing(2),
  },
}));

export const Divider = ({ 
  variant,
  orientation,
  thickness,
  color,
  marginTop,
  marginBottom
}) => {
  const classes = useStyles();
  const {
    connectors: { connect, drag },
  } = useNode();

  return (
    <MuiDivider
      ref={(ref) => connect(drag(ref))}
      className={classes.divider}
      variant={variant}
      orientation={orientation}
      style={{
        height: orientation === 'vertical' ? '100px' : `${thickness}px`,
        width: orientation === 'vertical' ? `${thickness}px` : '100%',
        backgroundColor: color,
        marginTop: `${marginTop}px`,
        marginBottom: `${marginBottom}px`,
      }}
    />
  );
};

const DividerSettings = () => {
  const classes = useStyles();
  const {
    actions: { setProp },
    variant,
    orientation,
    thickness,
    color,
    marginTop,
    marginBottom,
  } = useNode((node) => ({
    variant: node.data.props.variant,
    orientation: node.data.props.orientation,
    thickness: node.data.props.thickness,
    color: node.data.props.color,
    marginTop: node.data.props.marginTop,
    marginBottom: node.data.props.marginBottom,
  }));

  return (
    <div className={classes.settings}>
      <FormControl fullWidth margin="normal">
        <FormLabel>Variante</FormLabel>
        <TextField
          select
          value={variant}
          onChange={(e) => setProp((props) => (props.variant = e.target.value))}
          SelectProps={{
            native: true,
          }}
        >
          <option value="fullWidth">Ancho completo</option>
          <option value="inset">Con sangría</option>
          <option value="middle">Centro</option>
        </TextField>
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>Orientación</FormLabel>
        <TextField
          select
          value={orientation}
          onChange={(e) => setProp((props) => (props.orientation = e.target.value))}
          SelectProps={{
            native: true,
          }}
        >
          <option value="horizontal">Horizontal</option>
          <option value="vertical">Vertical</option>
        </TextField>
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>Grosor (px)</FormLabel>
        <TextField
          type="number"
          inputProps={{ min: 1, max: 10 }}
          value={thickness}
          onChange={(e) => setProp((props) => (props.thickness = e.target.value))}
        />
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>Color</FormLabel>
        <TextField
          type="color"
          value={color}
          onChange={(e) => setProp((props) => (props.color = e.target.value))}
        />
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>Margen superior (px)</FormLabel>
        <TextField
          type="number"
          value={marginTop}
          onChange={(e) => setProp((props) => (props.marginTop = e.target.value))}
        />
      </FormControl>

      <FormControl fullWidth margin="normal">
        <FormLabel>Margen inferior (px)</FormLabel>
        <TextField
          type="number"
          value={marginBottom}
          onChange={(e) => setProp((props) => (props.marginBottom = e.target.value))}
        />
      </FormControl>
    </div>
  );
};

Divider.craft = {
  props: {
    variant: 'fullWidth',
    orientation: 'horizontal',
    thickness: 1,
    color: 'rgba(0, 0, 0, 0.12)',
    marginTop: 16,
    marginBottom: 16,
  },
  related: {
    settings: DividerSettings,
  },
};
